import ExcelJS from 'exceljs';
import { CompanyNode } from '../types';

const isExternal = (n: CompanyNode): boolean =>
  n.country === 'EXT' || n.id.startsWith('ext-');

export async function buildExcelWorkbook(
  nodes: CompanyNode[]
): Promise<ExcelJS.Workbook> {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Organogram');
  const real = nodes.filter((n) => !isExternal(n));
  const maxShareholders = Math.max(
    1,
    ...real.map((n) => (n.shareholders ? n.shareholders.length : 0))
  );
  const headers: string[] = ['Land', 'Bedrijf', 'Bestuurders'];
  for (let i = 1; i <= maxShareholders; i++) {
    headers.push(`Aandeelhouder ${i}`, `% ${i}`);
  }
  ws.addRow(headers);
  ws.getRow(1).font = { bold: true };
  real.forEach((n) => {
    const row: any[] = [
      n.country || '',
      n.name,
      (n.directors || []).join('; '),
    ];
    for (let i = 0; i < maxShareholders; i++) {
      const sh = n.shareholders ? n.shareholders[i] : undefined;
      row.push(sh ? sh.name : '', sh ? sh.percentage : '');
    }
    ws.addRow(row);
  });
  return wb;
}

export async function downloadExcel(nodes: CompanyNode[]): Promise<void> {
  const wb = await buildExcelWorkbook(nodes);
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `org-chart-export-${new Date().toISOString().split('T')[0]}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
